import { Box, Grid, Skeleton } from '@factorialco/deprecated-design-system'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const LoadingLine = () => {
  return (
    <Box gap="s8">
      <Skeleton width="s80" height="s8" />
      <Skeleton width="s140" height="s8" />
    </Box>
  )
}

const LoadingBlock = () => {
  return (
    <Box gap="s16" flexDirection="column" data-testid="additional-compensations-loading">
      <Box flexDirection="row" gap="s8" alignItems="center">
        <Skeleton width="s24" height="s24" />
        <Skeleton width="s200" height="s24" />
      </Box>
      <Box
        gap="s32"
        padding="s24"
        border={{
          all: {
            width: 's2',
            color: 'grey400',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        height="full"
      >
        <LoadingLine />
        <LoadingLine />
        <LoadingLine />
      </Box>
    </Box>
  )
}

const LoadingHeader = () => {
  return (
    <Box gap="s8">
      <Box gap="s8" flexDirection="row" justifyContent="spaceBetween">
        <Box gap="s8">
          <Skeleton width="s300" height="s8" />
          <Skeleton width="s400" height="s8" />
        </Box>
        <Box gap="s8">
          <Skeleton width="s240" height="s32" />
        </Box>
      </Box>
    </Box>
  )
}

const LoadingState = () => {
  return (
    <ResponsivePage.Body>
      <Grid variant="fixed">
        <Box
          style={{
            position: 'relative',
            gridColumnStart: '2',
            gridColumnEnd: 'span 10',
          }}
          paddingBottom="s48"
          gridColSpan={{ xxs: 10 }}
          gap="s40"
        >
          <Box gap="s48">
            <LoadingHeader />
            <Box gap="s40">
              <LoadingBlock />
              <LoadingBlock />
              <LoadingBlock />
              <LoadingBlock />
              <LoadingBlock />
              <LoadingBlock />
            </Box>
          </Box>
        </Box>
      </Grid>
    </ResponsivePage.Body>
  )
}

export default LoadingState
